require('./bootstrap');

require('jquery');
require('jquery-lazy');
require('jquery-validation');

require('corejs-typeahead');
